<script>
import {
  CdrGrid,
} from '@rei/cedar';
import LandingCard from './LandingCard.vue';

export default {
  name: 'LandingArticles',
  components: {
    CdrGrid,
    LandingCard,
  },
  props: {
    cards: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    baseClassName: 'ea-article-grid',
  }),
  computed: {
    cardsOne() {
      return this.cards.filter((card, i) => i <= 2);
    },
    cardsTwo() {
      return this.cards.filter((card, i) => i > 2);
    },
    renderGrid() {
      return this.cards && this.cards.length === 6;
    },
  },
  methods: {
    getSpanOne(i) {
      return i === 0 ? 'full' : 'half';
    },
    getSpanTwo(i) {
      return i === 2 ? 'full' : 'half';
    },
  },
};
</script>

<template>
  <section
    v-if="renderGrid"
    id="ea_article-grid"
    :class="`${baseClassName}`"
  >
    <cdr-grid
      :class="`${baseClassName}__grid`"
    >
      <cdr-grid
        :class="`${baseClassName}__sub-grid`"
      >
        <landing-card
          v-for="(card, i) in cardsOne"
          :key="`cards-one-${i}`"
          :card="card"
          :class="`${baseClassName}__${getSpanOne(i)}`"
        />
      </cdr-grid>
      <cdr-grid
        :class="`${baseClassName}__sub-grid`"
      >
        <landing-card
          v-for="(card, i) in cardsTwo"
          :key="`cards-two-${i}`"
          :card="card"
          :class="`${baseClassName}__${getSpanTwo(i)}`"
        />
      </cdr-grid>
    </cdr-grid>
  </section>
</template>
<style lang="scss">
  @import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

  $baseClassName: 'ea-article-grid';

.#{$baseClassName} {
  @include cdr-container;
  .#{$baseClassName}__heading {
    @include cdr-text-heading-sans-600;
    margin-bottom: $cdr-space-one-x;
  }
  .#{$baseClassName}__grid {
    grid-template-columns: 1fr;
    @include cdr-md-mq-up {
      grid-template-columns: 1fr 1fr;
    }
  }
  .#{$baseClassName}__sub-grid {
      grid-template-columns: 1fr 1fr;
  }
  .#{$baseClassName}__full {
    grid-column: span 2;
  }
  .#{$baseClassName}__half {
    grid-column: span 2;
    @include cdr-md-mq-up {
      grid-column: span 1;
    }
  }
}
</style>
